<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tITwk6/tc-custom/9781446359921.jpg?1737056308027" alt="This image is the cover for the book Simple Knits: Cushions & Pillows, Simple Knits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Simple Knits: Cushions & Pillows, Simple Knits
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Patterns for the coziest and cutest cushions, seating cubes, and pillows from the established designer and bestselling author of <i>The Knitter’s Bible</i>.</b><br/>  <br/> Featuring strong designs across a range of styles for the new-to-knitting market, all the projects included are either Beginner, Easy or Intermediate skill level, and the majority are Easy. As well as patterns and project instructions, you will also find an explanation of the abbreviations used, a knitting needle conversion chart, a skill level key, a standard yarn weight chart, knitting techniques and making-up techniques.<br/>  <br/> Projects include:<br/> · Pompom Cushion<br/> · Bright Stripe Pillows<br/> · Beaded Cushions<br/> · Black and White Pillow<br/> · Vibrant Seating Cube<br/> · Fringed Ribbon Pillow<br/> · French Knitted Cushions<br/> · Blooming Rose Pillow<br/> · Diamond Pattern Pillow<br/> · Bunting Cushion</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claire Crompton
      </h2>
      
      <p class="authorDescription body article"> Claire Crompton has worked as a pattern cutter, sample garment maker, and a hand-knitting designer and pattern writer. She has also worked as a cross stitch designer for a large needlecraft company, developing skills in charting and writing embroidery instructions for kits and booklets. Claire is now a workshop tutor and author of several books on cross stitch and knitting, including the bestsellingKnitter&#39;s Bible series. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?016c4835